import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiCopy}=FiIcons;

const EmbedCodeGenerator=({campaign,onCopy})=> {
  // Ensure the embed URL always uses https
  const protocol = window.location.protocol === 'https:' ? 'https:' : 'https:';
  const host = window.location.host;
  const embedUrl=`${protocol}//${host}/v1/c.js`;
  const embedCode=`<script src="${embedUrl}" data-cid="${campaign.public_id}" async></script>`;

  const handleCopy=()=> {
    navigator.clipboard.writeText(embedCode);
    if (onCopy) onCopy();
  };

  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Embed Code
        </label>
        <div className="relative">
          <pre className="bg-gray-900 text-gray-100 p-4 rounded-md text-sm overflow-x-auto">
            <code>{embedCode}</code>
          </pre>
          <button
            onClick={handleCopy}
            className="absolute top-2 right-2 p-2 text-gray-400 hover:text-white transition-colors"
            title="Copy embed code"
          >
            <SafeIcon icon={FiCopy} className="h-4 w-4" />
          </button>
        </div>
      </div>

      <div className="bg-blue-50 border border-blue-200 rounded-md p-4">
        <h3 className="text-sm font-medium text-blue-900 mb-2">
          How to Install
        </h3>
        <ol className="text-sm text-blue-800 space-y-1">
          <li>1. Copy the embed code above</li>
          <li>2. Paste it in your website's HTML</li>
          <li>3. Place it before the closing &lt;/body&gt; tag</li>
          <li>4. Social proof notifications will appear automatically</li>
        </ol>
      </div>
    </div>
  );
};

export default EmbedCodeGenerator;